// extracted by mini-css-extract-plugin
export default {"return":"PollsError_return__sxz6p"};